import React from 'react';
import {Link, type LinkProps} from 'react-router';

/**
 * Wraps react-router's Link with React.forwardRef so MUI's
 * prop-type check recognizes it as a ref-forwarding component.
 */
const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function RouterLink(props, ref) {
    return <Link ref={ref} {...props} />;
  },
);

export default RouterLink;
